import { Message } from "element-ui";
import { handleAuthError } from "./authError";

export const handleNetworkError = (errStatus) => {
    let errMessage = "未知错误";
    if (errStatus) {
        switch (errStatus) {
            case 400:
                errMessage = "错误的请求";
                break;
            case 401:
                errMessage = "接口未授权";
                break;
            case 403:
                errMessage = "您太久没登录，请重新登录~";
                handleAuthError(errStatus);
                break;
            case 404:
                errMessage = "请求错误,未找到该资源";
                break;
            case 405:
                errMessage = "请求方法未允许";
                break;
            case 408:
                errMessage = "请求超时";
                break;
            case 500:
                errMessage = "服务器端出错";
                break;
            case 501:
                errMessage = "网络未实现";
                break;
            case 502:
                errMessage = "网络错误";
                break;
            case 503:
                errMessage = "服务不可用";
                break;
            case 504:
                errMessage = "网络超时";
                break;
            case 505:
                errMessage = "http版本不支持该请求";
                break;
            default:
                errMessage = `其他连接错误 --${errStatus}`;
        }
    } else {
        errMessage = `无法连接到服务器！`;
    }
    if (errStatus !== 403) {
        Message({
            message: errMessage,
            showClose: true,
            type: "error",
        });
    }
};

export const handleGeneralError = (response) => {
    //500 业务繁忙
    if (response.data.code === 500) {
        Message({
            message: response.data.msg,
            showClose: true,
            type: "error",
        });
    }
};
